import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";

const getHeadersInvoiceItems = {
    namespaced: true,
    state: {
        headers: []
    },
    mutations: {
        GET_HEADERS_TABLE_SUCCESS(state, response) {
            response.data.forEach(el => el.class = "table-headers");
            state.headers = response.data;
        },
        GET_HEADERS_TABLE_FAILURE(state, error) {
            let dataReceive = {
                title: error.response.data.message,
                message: handleError(error) !== "" ? handleError(error) : error.response.data.data.message
            }
            eventBus.$emit("operationFailure", dataReceive);
        }
    },
    actions: {
        getHeadersInvoiceItems: function({ dispatch }) {
            let promise = sendRequest("get", config.baseURLApi + "/invoices/tableHeaders/getInvoicesTableHeaders", {})
            promise.then(function (result) {
                if(result[0] === "success") {
                    dispatch("successGetHeadersTable", result[1]);
                } else {
                    dispatch("failureGetHeadersTable", result[1]);
                }
            })
        },
        successGetHeadersTable: function({ commit }, response) {
            commit("GET_HEADERS_TABLE_SUCCESS", response);
        },
        failureGetHeadersTable: function({ commit }, error) {
            commit("GET_HEADERS_TABLE_FAILURE", error);
        }
    }
}

export default getHeadersInvoiceItems;